export function calculateSubTotal(products) {
  return products.reduce((val, product) => {
    const isGourmet = product.product_type === 'App\\Models\\GourmetProduct'
    const isPriceNull =
      product.item?.reference_price == null && product.reference_price == null
    const referencePrice =
      isGourmet || isPriceNull
        ? product.item?.price ?? product.price
        : product.item?.reference_price ?? product.reference_price

    return val + product.qty * referencePrice
  }, 0)
}

export function calculateDisscount(products) {
  return products.reduce((totalDiscount, product) => {
    const referencePrice =
      product.item?.reference_price ?? product.reference_price
    const currentPrice = product.item?.price ?? product.price
    const quantity = product.qty

    // Solo aplica si hay diferencia y ambos precios existen
    if (referencePrice && currentPrice && referencePrice > currentPrice) {
      const discountPerUnit = referencePrice - currentPrice
      totalDiscount += discountPerUnit * quantity
    }

    return totalDiscount
  }, 0)
}

export function calculateTotal(products) {
  return products.reduce(
    (val, product) =>
      val +
      product.qty * (product.item?.price ? product.item.price : product.price),
    0
  )
}

export function getProductName(product) {
  let name = ''
  if (product.name) name += product.name
  if (product.detail) name += '- ' + product.detail
  if (product.year) name += ', ' + product.year
  return name
}

const currencyFormatter = new Intl.NumberFormat('es-CL', {
  style: 'currency',
  currency: 'USD',
  currencyDisplay: 'narrowSymbol',
  trailingZeroDisplay: 'stripIfInteger',
})

export function getProductPrice(price) {
  return currencyFormatter.format(price)
}
